<template>
  <teleport to="body">
    <div v-if="visible" class="sa-overlay" @click.self="close">
      <div class="sa-dialog" role="dialog">
        <header class="sa-header">
          <h2>{{ title }}</h2>
          <button v-if="dismissible" type="button" class="sa-close" aria-label="关闭" @click="close">&times;</button>
        </header>
        <div class="sa-body" v-html="formattedContent"></div>
        <footer v-if="dismissible" class="sa-footer">
          <el-button type="primary" @click="close">我知道了</el-button>
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'SiteAnnouncementDialog',
  props: {
    scene: { type: String, default: 'home' },
    storageKey: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      title: '通知',
      content: '',
      dismissible: true,
      contentVersion: ''
    }
  },
  computed: {
    formattedContent() {
      const c = this.content || ''
      if (/<[a-z][\s\S]*>/i.test(c)) return c
      return c.split('\n').map(line => `<p>${this.escapeHtml(line)}</p>`).join('')
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    },
    getDismissKey(version) {
      const base = this.storageKey || `announcement_dismissed_${this.scene}`
      return version ? `${base}_${version}` : base
    },
    async load() {
      try {
        const { getAnnouncement } = await import('@/services/api')
        const { data } = await getAnnouncement(this.scene)
        if (!data?.enabled) return
        const version = data.updatedAt || `${data.title || ''}|${data.content || ''}`
        const dismissKey = this.getDismissKey(version)
        if (sessionStorage.getItem(dismissKey)) return
        this.title = data.title || '通知'
        this.content = data.content || ''
        this.dismissible = data.dismissible !== false
        this.contentVersion = version
        this.visible = true
      } catch (e) {
        console.warn('加载公告失败', e)
      }
    },
    close() {
      this.visible = false
      const dismissKey = this.getDismissKey(this.contentVersion)
      sessionStorage.setItem(dismissKey, '1')
    }
  }
}
</script>

<style scoped>
.sa-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.sa-dialog {
  width: min(560px, 96vw);
  max-height: 80vh;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(90deg, #1e3c72, #2a5298);
  color: #fff;
}
.sa-header h2 {
  margin: 0;
  font-size: 18px;
}
.sa-close {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
}
.sa-body {
  padding: 20px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.7;
  color: #333;
}
.sa-body :deep(p) {
  margin: 0 0 10px;
}
.sa-footer {
  padding: 12px 20px 16px;
  text-align: right;
  border-top: 1px solid #eee;
}
</style>
